import * as actions from "./actions";
import { rootRef } from "../../config/firebase";

function resetSavedData() {
  return actions.resetDataSaved();
}

function eliminarColegio(idAlumno) {
  return dispatch => console.log("*** PENDIENTE DE IMPLEMENTAR ***");
}

function obtenerDetalleColegio(idColegio) {
  return dispatch => {
    rootRef.child(`detalles/colegios/${idColegio}`).once("value", snap => {
      const payload = { ...snap.val(), ...{ id: snap.key } };
      dispatch(actions.obtenerDetalleColegio(payload));
    });
  };
}

function resetDetalleColegio() {
  return actions.resetDetalleColegio();
}

function obtenerListaColegios() {
  return dispatch => {
    rootRef.child("detalles/colegios").on("child_added", snap => {
      const payload = { ...snap.val(), ...{ id: snap.key } };
      dispatch(actions.obtenerListaColegios(payload));
    });
  };
}

function resetListaColegios() {
  return actions.resetListaColegios();
}

function saveDataColegio(values) {
  const idColegio = rootRef.child("detalles/colegios").push().key;
  values.nombre = values.nombre.trim().toUpperCase();
  let insert = {};
  insert[`detalles/colegios/${idColegio}`] = values;
  return dispatch => rootRef.update(insert);
}

function updateDataColegio(values) {
  values.nombre = values.nombre.trim().toUpperCase();
  let insert = {};
  insert[`detalles/colegios/${values.id}`] = values;
  return dispatch => rootRef.update(insert);
}

/*---*/
export {
  resetSavedData,
  eliminarColegio,
  obtenerListaColegios,
  resetListaColegios,
  obtenerDetalleColegio,
  updateDataColegio,
  resetDetalleColegio,
  saveDataColegio
};



// WEBPACK FOOTER //
// ./src/ducks/colegios/operations.js